import Logger from '../logger';
import event from '../mixins/event';
import simpleParallax from 'simple-parallax-js';

class BannerHero {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'BannerHero';

		this.dom = dom;

		this.parallaxImages = this.dom.querySelectorAll(`[data-banner-hero-image]`);

	}

	/**
	 * init - Initialize the form
	 */
	init() {
		Logger.info(`${this.NAME} > init`);
		this.initParallax();
	}

	/**
	 * initParallax - Initialize the parallax effect
	 */
	initParallax() {
		Logger.info(`${this.NAME} > initParallax`);

		if (!this.parallaxImages) return;

		new simpleParallax(this.parallaxImages, {
			delay: 0.1,
			orientation: 'down',
			scale: 1.3
		});

	}

}

Object.assign(BannerHero.prototype, event);

export default BannerHero;
